import { defineComponent, reactive, ref } from "vue";
import { QuantityTableService as ContractQuantityService } from "@/views/subcontract-management";
import { columns } from "./subcontract-quantity-select.constant";
/**
 * 从合同中选择工程量清单
 */
export default defineComponent({
  name: "SubContractQuantitySelect",
  props: {
    contractId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  emits: ["ok"],
  setup(props, { emit }) {
    const visible = ref(false);
    const queryRef = reactive({ name: "" });
    const { data: dataSource, loading, run } = ContractQuantityService.useQuantityListApi();

    const showModal = async () => {
      const param = {
        projectId: props.projectId,
        name: queryRef.name,
      };
      if (props.projectId) {
        await run(props.projectId, queryRef.name);
      }
      visible.value = true;
    };
    const closeModal = () => {
      visible.value = false;
      queryRef.name = ""
    };

    const search = async () => {
      showModal();
    };

    const ok = () => {
      if (selectedIds.value.length) {
        const quantities = (dataSource.value?.records || []).filter((item) =>
          selectedIds.value.includes(item.id)
        );
        emit("ok", quantities);
      }
      closeModal();
    };

    const selectedIds = ref<string[]>([]);
    const onSelectionChange = (ids: string[]) => {
      selectedIds.value = ids;
    };

    return {
      visible,
      showModal,
      closeModal,
      ok,
      queryRef,
      loading,
      dataSource,
      columns,
      selectedIds,
      onSelectionChange,
      search,
    };
  },
});
